import { ErrorRoutePath } from "app/constants/routePaths";
import ShiftHandoverScreen from "app/screens/shiftHandover/ShiftHandoverScreen";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { Redirect } from "expo-router";

export default function ShiftHandoverPage() {
  const { checkPermission } = usePermissionCheck();

  if (!checkPermission(PermissionsEnums.VIEW_SHIFT_HANDOVER))
    return <Redirect href={ErrorRoutePath} />;

  return <ShiftHandoverScreen />;
}
